import { render, staticRenderFns } from "./slide-config.vue?vue&type=template&id=7b2ce662&scoped=true"
import script from "./slide-config.vue?vue&type=script&lang=js"
export * from "./slide-config.vue?vue&type=script&lang=js"
import style0 from "./slide-config.vue?vue&type=style&index=0&id=7b2ce662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ce662",
  null
  
)

export default component.exports